import { render, staticRenderFns } from "./SideBarBase.vue?vue&type=template&id=5509ab08&scoped=true&"
import script from "./SideBarBase.vue?vue&type=script&lang=ts&"
export * from "./SideBarBase.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarBase.vue?vue&type=style&index=0&id=5509ab08&lang=scss&scoped=true&"
import style1 from "./SideBarBase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509ab08",
  null
  
)

export default component.exports